import React, { useState, useEffect, useRef } from "react";
import ReactToPrint from "react-to-print";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Table,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  ModalFooter,
} from "reactstrap";
import moment from "moment";
import * as Icons from "react-feather";
import { urlAPI, getUser, getToken } from "utility/Common";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import Axios from "axios";
import { useDispatch } from "react-redux";
import NumberFormat from "react-number-format";
import TextTruncate from "react-text-truncate";
import Select from "react-select";
import NumberInput from "components/NumberInput";
import Center from "react-center";

export default function ModalSelected(props) {
  const {
    open,
    setOpen,
    data,
    setData,
    kepada,
    selectorAccount,
    loadingAccount,
    selectorCostCenter,
    selectorKompilator,
    loadingKompilatorDanCC,
    handleDone,
  } = props;

  return (
    <Modal
      isOpen={open}
      toggle={() => setOpen(false)}
      className="modal-dialog-centered modal-lg"
      backdrop="static"
    >
      <ModalHeader toggle={() => setOpen(false)}></ModalHeader>
      <ModalBody>
        {kepada === "" || kepada === null || !kepada ? (
          <>
            <br />
            <Center>
              <h4>Mohon pilih Kepada / Customer terlebih dahulu</h4>
            </Center>
          </>
        ) : (
          <>
            <FormGroup>
              <Label>TB</Label>
              <Input
                type="text"
                name="faktur"
                id="faktur"
                value={data[0]?.NOTB}
                disabled={true}
              />
            </FormGroup>
            <hr />
            <FormGroup>
              <Label>Keterangan</Label>
              <Input
                type="textarea"
                rows="2"
                id="KET"
                name="KET"
                value={data[0]?.KET}
                onChange={(e) => {
                  let tempEdit = data;
                  tempEdit[0] = {
                    ...data[0],
                    KET: e.target.value,
                  };
                  setData([...tempEdit]);
                }}
              />
            </FormGroup>
            <Row>
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <Label>Rekening</Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="AKUN"
                    name="AKUN"
                    options={selectorAccount}
                    value={selectorAccount?.find(
                      (find) => find.value === data[0]?.AKUN
                    )}
                    isLoading={loadingAccount}
                    isDisabled={data[0]?.NOTB !== "LL"}
                    onChange={(e) => {
                      let tempEdit = data;
                      tempEdit[0] = {
                        ...data[0],
                        AKUN: e.value,
                      };
                      setData([...tempEdit]);
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Kompilator</Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="KOMP"
                    name="KOMP"
                    options={selectorKompilator}
                    value={selectorKompilator?.find(
                      (find) => find.value === data[0]?.KOMP
                    )}
                    isLoading={loadingKompilatorDanCC}
                    isClearable={true}
                    onChange={(e) => {
                      let tempEdit = data;
                      tempEdit[0] = {
                        ...data[0],
                        KOMP: e?.value ? e?.value : "",
                      };
                      setData([...tempEdit]);
                    }}
                  />
                </FormGroup>
              </Col>
              <Col lg="6" md="6" sm="12">
                <FormGroup>
                  <Label>Cost Center</Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="CC"
                    name="CC"
                    options={selectorCostCenter}
                    value={selectorCostCenter?.find(
                      (find) => find.value === data[0]?.CC
                    )}
                    isLoading={loadingKompilatorDanCC}
                    isClearable={true}
                    onChange={(e) => {
                      let tempEdit = data;
                      tempEdit[0] = {
                        ...data[0],
                        CC: e?.value ? e?.value : "",
                      };
                      setData([...tempEdit]);
                    }}
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Aktivitas</Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="AKT"
                    name="AKT"
                    options={selectorAccount}
                    value={selectorAccount?.find(
                      (find) => find.value === data[0]?.AKT
                    )}
                    isLoading={loadingAccount}
                    isClearable={true}
                    onChange={(e) => {
                      let tempEdit = data;
                      tempEdit[0] = {
                        ...data[0],
                        AKT: e?.value ? e?.value : "",
                      };
                      setData([...tempEdit]);
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label>Jumlah</Label>
              <NumberInput
                name="K"
                id="K"
                // decimal
                value={
                  Number(data[0]?.K) > 0
                    ? Number(data[0]?.K)
                    : Number(data[0]?.D) > 0
                    ? Number(data[0]?.D)
                    : 0
                }
                disabled={true}
              />
            </FormGroup>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={() => {
            handleDone();
          }}
          disabled={data[0]?.NOTB === "" || data[0]?.NOTB === null}
        >
          Tambahkan
        </Button>
      </ModalFooter>
    </Modal>
  );
}
